import { Option } from '@mui/base';
import { CustomSelect } from '../../../../../../../../../common/Styleguide/Common/Select';
import { DEVICE_FILTER_OPTIONS, DeviceFilterOptionsValues } from '../../../../../../../../helpers/metricsHelpers';
import React from 'react';

type DeviceFilterProps = {
  value: DeviceFilterOptionsValues;
  setValue: React.Dispatch<React.SetStateAction<DeviceFilterOptionsValues>>;
};

const DeviceFilter: React.FC<DeviceFilterProps> = ({ value, setValue }) => {
  return (
    <CustomSelect style={{ height: 40, width: 200 }} value={value} onChange={(_, value) => setValue(value as DeviceFilterOptionsValues)}>
      {DEVICE_FILTER_OPTIONS.map((option, i) => {
        return (
          <Option key={i} value={option.value}>
            {option.label}
          </Option>
        );
      })}
    </CustomSelect>
  );
};

export default DeviceFilter;
